import Vue from 'vue';
import { assign, has, get, find, each } from 'lodash';
import * as KEYS from 'constants/keys';
import * as api from 'api/api-stuff-to-do';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  StuffToDoList: state => type => state[type],
};

const actions = {
  GetStuffToDoList({ commit }, parameters) {
    const type = parameters.type;
    const params = parameters.params;
    commit(types.FETCH_STUFF_TO_DO_LIST_START, { type });
    api.getIndexList(
      type,
      params,
      (response) => {
        commit(types.RECEIVE_STUFF_TO_DO_LIST, { type, response });
      },
      (description, status, error) => {
        commit(types.FETCH_STUFF_TO_DO_LIST_ERROR, { type, error });
      },
    );
  },
  AddToRecentlyModifiedList({ commit }, params) {
    const type = params.type;
    const response = params.response;
    commit(types.ADD_TO_RECENTLY_MODIFIED_LIST, { type, response });
  },
  RemoveFromRecentlyModifiedList({ commit }, params) {
    const type = params.type;
    const id = params.id;
    commit(types.REMOVE_FROM_RECENTLY_MODIFIED_LIST, { type, id });
  },
  ClearStuffToDoList({ commit }, type) {
    commit(types.CLEAR_STUFF_TO_DO_LIST_STORE, { type });
  },
};

const mutations = {
  [types.FETCH_STUFF_TO_DO_LIST_START](state, { type }) {
    console.log('FETCH_STUFF_TO_DO_LIST_START', type);
    if (has(state, type)) Vue.set(state, type, assign(state[type], neutralState, { fetching: true }));
    else Vue.set(state, type, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_STUFF_TO_DO_LIST_ERROR](state, { type, error }) {
    console.log('FETCH_STUFF_TO_DO_LIST_ERROR', type);
    Vue.set(state, type, assign(state[type], neutralState, { error }));
  },
  [types.RECEIVE_STUFF_TO_DO_LIST](state, { type, response }) {
    console.log('RECEIVE_STUFF_TO_DO_LIST', response);
    Vue.set(state, type, assign(state[type], neutralState, { ready: true, meta: response.meta, data: response.data }));
  },
  [types.CLEAR_STUFF_TO_DO_LIST_STORE](state, { type }) {
    console.log('CLEAR_STUFF_TO_DO_LIST_STORE');
    Vue.delete(state, type);
  },
  [types.ADD_TO_RECENTLY_MODIFIED_LIST](state, { type, response }) {
    const data = get(state, `${type}.data`);
    const recentlyModifiedList = find(data, item => item.code === KEYS.RECENTLY_MODIFIED);
    console.log('ADD_TO_RECENTLY_MODIFIED_LIST', data, recentlyModifiedList);
    if (recentlyModifiedList) recentlyModifiedList.items.unshift(response.data);
  },
  [types.REMOVE_FROM_RECENTLY_MODIFIED_LIST](state, { type, id }) {
    const data = get(state, `${type}.data`);
    each(data, (list, key) => {
      const stuffToDo = find(list, { id });
      if (stuffToDo) {
        Vue.delete(list, id);
        if (list.lenght === 0) Vue.delete(data, key);
      }
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-do/entities/stuff-to-do-list.js